import React from 'react'

import Drawer from 'src/components/atoms/drawer'
import { DrawerHeader } from 'src/components/molecules/drawerHeader'
import ActionToolbar from 'src/components/organisms/actionToolbar'
import { drawerActions, useDrawerStore } from 'src/store/drawer'

import { Grid } from 'antd'

const { useBreakpoint } = Grid

const GlobalDrawerRenderer: React.FC = () => {
    const { drawers } = useDrawerStore()
    const { xl, xxl } = useBreakpoint()

    const handleCloseDrawer = (drawerIndex: number) => {
        const drawer = drawers[drawerIndex]
        if (drawer?.onClose) {
            drawer.onClose()
        }
        drawerActions.removeDrawer(drawerIndex)
    }

    const getDefaultWidth = () => {
        if (xxl) {
            return '70%'
        } else if (xl) {
            return '60%'
        } else {
            return '50%'
        }
    }

    return (
        <>
            {drawers.map((drawer, drawerIndex) => (
                <React.Fragment key={drawer.index}>
                    {drawer.actionContext}

                    <Drawer
                        open={drawer.open}
                        onClose={() => handleCloseDrawer(drawerIndex)}
                        title={
                            drawer.title || drawer.actions ? (
                                <DrawerHeader
                                    left={drawer.title ? drawer.title : null}
                                    right={
                                        drawer.actions ? (
                                            <ActionToolbar className="ml-auto" actions={drawer.actions} />
                                        ) : null
                                    }
                                />
                            ) : undefined
                        }
                        width={drawer.width || getDefaultWidth()}
                        placement={drawer.placement || 'right'}
                        drawerRender={drawer.drawerRender}
                        destroyOnClose
                        styles={{
                            body: {
                                padding: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden',
                                height: '100%',
                            },
                        }}
                    >
                        {drawer.content || <div>No content</div>}
                    </Drawer>
                </React.Fragment>
            ))}
        </>
    )
}

export default GlobalDrawerRenderer
